if($('.testimonial-block').length) {

    $('.testimonial-block').each(function () {

        let testimonialSlider = $(this).find('.testimonial-slider'),
            mobileArrowPrev = $(this).find('.testimonial-slider-mobile-arrows .slick-prev'),
            mobileArrowNext = $(this).find('.testimonial-slider-mobile-arrows .slick-next');

        testimonialSlider.slick({
            autoplay: true,
            fade: true,
            arrows: true,
            autoplaySpeed: testimonialSlider.data('slider-speed'),
            infinite: true,
            adaptiveHeight: true,
            prevArrow: '<button type="button" class="desktop-only slick-prev"><img src="/assets/img/controls/prev-slide-arrow-black.svg" alt="Previous Project"></button>',
            nextArrow: '<button type="button" class="desktop-only slick-next"><img src="/assets/img/controls/next-slide-arrow-black.svg" alt="Next Project"></button>'
        });

        mobileArrowPrev.on('click', function () {
            testimonialSlider.slick('slickPrev');
        });

        mobileArrowNext.on('click', function () {
            testimonialSlider.slick('slickNext');
        });

    });

}
